// extracted by mini-css-extract-plugin
export default {"decoration":"DecoratedText_decoration__iQxIw","text":"DecoratedText_text__FBelm","decoratedText":"DecoratedText_decoratedText__4Ywts"};